import React from 'react'
import Skeleton from 'react-loading-skeleton'

function RendezVousSkeleton() {
  return (
         <div className="skeleton-container">
                {[...Array(5)].map((_, index) => (
                  <div
                    key={index}
                    className="skeleton-row"
                    style={{ display: "flex", gap: "16px", padding: "12px 0" }}
                  >
                    <Skeleton width={80} height={20} />
                    <Skeleton width={60} height={20} />
                    <Skeleton width={80} height={20} />
                    <Skeleton width={90} height={20} />
                    <Skeleton width={180} height={20} />
                    <Skeleton width={60} height={20} />
                    <Skeleton width={60} height={20} />
                    <Skeleton width={60} height={20} />
                  </div>
                ))}
              </div>
  )
}

export default RendezVousSkeleton